<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { makeWebsiteRequest } from "../../Common/tools";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let period = null,
    funnel = null,
    filters = [],
    contact = 0,
    search = "",
    options = {};

  const dispatch = createEventDispatcher();

  let loading = true,
    initialLoad = true,
    currentPage = 0,
    pagesCount = 0,
    itemsCount = 0,
    table = null,
    selection = null;

  let tableColumns = [
    {
      key: "name",
      disableNameInitials: true,
      label: M.PRODUCT_NAME,
      class: "flex-none mw-240",
      style: "font-size: 13px"
    },
    {
      key: "activeSubs",
      label: M.SUBSCRIBED,
      class: "flex-none mw-140",
      style: "font-size: 13px"
    },
    {
      key: "expiredSubsLbl",
      label: M.CANCELED_LBL,
      class: "flex-none mw-140",
      style: "font-size: 13px"
    },
    {
      key: "finishedSubs",
      label: M.FINISHED,
      class: "flex-none mw-140",
      style: "font-size: 13px"
    },
    {
      key: "mrr",
      label: M.MRR_LBL,
      style: "font-size: 18px",
      class: "flex-none mw-240"
    },
    {
      key: "ofAll",
      label: M.PERCENT_SUBS,
      class: "flex-none",
      type: "progressbar"
    }
  ];

  let tableData = {
    columns: tableColumns,
    rows: []
  };

  let setRequestFilter = (request, stringify) => {
    request = request || {};

    request.contact = contact;

    if (filters.length > 0) {
      request.filters = stringify ? JSON.stringify(filters) : filters;
    }

    if (funnel) {
      request.funnel = funnel;
    }
    if (period && period.from) {
      request.from = External.Tools.dateToISOStr(period.from);
    }

    if (period && period.to) {
      request.to = External.Tools.dateToISOStr(period.to);
    }

    request.search = search;
    return request;
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      tableData.rows = [];
      selection = null;
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let request = setRequestFilter(
      {
        page: page
      },
      true
    );

    let response = await makeWebsiteRequest({
      action: "getStoreSubscriptionProducts",
      method: "post",
      data: request
    });

    loading = false;
    if (!response.data) return;

    let products = response.data.products;
    let totalMrr = response.data.totalMrr;

    currentPage = page;
    pagesCount = products.pagesCount;
    itemsCount = products.count;

    products.items.forEach((item) => {
      let allSubscriptions = item.activeSubs + item.expiredSubs + item.finishedSubs
      let churnPercent = ((item.expiredSubs / allSubscriptions) * 100).toFixed(2);
      item.expiredSubsLbl = item.expiredSubs + ' (' + churnPercent + '%)';
      item.ofAll = item.mrr / totalMrr;
      item.mrr = External.WebPlatform.currToStr(item.mrr, External.Website.storeCurrencySymbol, External.Website.storeCurrencyPositionAtLeft, External.Website.storeCurrency, External.Website.storeCountry);
    });

    if (page === 0) {
      dispatch("itemsloaded", {
        count: itemsCount
      });
    }
    if (table) {
      table.addRows(products.items);
    }
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let onClickRow = (row) => {
    if (options.click === false) {
      return;
    }
  };

  export function reload() {
    load(0);
  }

  function getSelectedItemsCount() {
    if (selection !== null) {
      if (selection.all) return itemsCount - selection.unselected.length;
      else return selection.selected.length;
    }
    return itemsCount;
  }

  onMount(() => {
    load(0);
  });
</script>

<Table
  bind:this={table}
  activeColumns={tableData.columns}
  data={tableData.rows}
  loading={loading}
  hideHeadOnLoad={true}
  hasSelection={false}
  bind:selection
  onClick={onClickRow}
  nextPage={onNext}
  tableClass={"orders-scrollable-table"}>
  <div class="col20 f-left coming-soon-block">
    <div class="col20 f-left t-center mb-25">
      <span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
    </div>
    <div class="col20 f-left t-center">
      <h3>{M.NO_DATA_YET}</h3>
    </div>
  </div>
</Table>
